import { graphql } from '../graphql';

// Create a new subscription
export const createSubscriptionMutation = graphql(`
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      type
      url
    }
  }
`);

// Update storage blocks
export const updateSubscriptionStorageMutation = graphql(`
  mutation UpdateSubscriptionStorage($input: UpdateStorageInput!) {
    updateSubscriptionStorage(input: $input)
  }
`);

// Change subscription tier
export const changeSubscriptionTierMutation = graphql(`
  mutation ChangeSubscriptionTier($input: ChangeTierInput!) {
    changeSubscriptionTier(input: $input)
  }
`);

// Cancel subscription
export const cancelSubscriptionMutation = graphql(`
  mutation CancelSubscription($organizationId: ID!) {
    cancelSubscription(organizationId: $organizationId)
  }
`);

// Reactivate subscription
export const reactivateSubscriptionMutation = graphql(`
  mutation ReactivateSubscription($organizationId: ID!) {
    reactivateSubscription(organizationId: $organizationId)
  }
`);

// Apply discount/promo code
export const applySubscriptionDiscountMutation = graphql(`
  mutation ApplySubscriptionDiscount($input: ApplyDiscountInput!) {
    applySubscriptionDiscount(input: $input)
  }
`);

// Remove discount
export const removeSubscriptionDiscountMutation = graphql(`
  mutation RemoveSubscriptionDiscount($organizationId: ID!) {
    removeSubscriptionDiscount(organizationId: $organizationId)
  }
`);

// Create billing portal session
export const createBillingPortalSessionMutation = graphql(`
  mutation CreateBillingPortalSession($organizationId: ID!, $returnUrl: String!) {
    createBillingPortalSession(organizationId: $organizationId, returnUrl: $returnUrl)
  }
`);
